import React from "react";
import Navbar from "../Components/Navbar";
import subpagebanner from "../Assets/subpagebanner.png";
import timeline from "../Assets/timeline.png";
import footer from "../Assets/footer.png";

const About = () => {
  return (
    <div className="App">
      <Navbar />
      <img src={subpagebanner} alt="" />
      <div className="home-container"></div>
      <div className="bodycopy-container">
        <h1 className="primary-header">Timeline</h1>

        <img
          src={timeline}
          alt="Challenge Timeline"
          useMap="#timeline-map"
          style={{ maxWidth: "100%", height: "auto" }}
        />

        <map name="timeline-map">
          <area
            shape="rect"
            coords="500,900,960,1000"
            href="https://nus-sg.zoom.us/j/88415799148?pwd=wdaNW5AliTyZJpSDOYAa0BxhsW3bbw.1"
            target="_blank"
            rel="noopener noreferrer"
            alt="Innovation Kickoff Link"
          />
        </map>

        <img src={footer} alt="" />
      </div>
    </div>
  );
};

export default About;
